var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C7.038 3 3 7.038 3 12C3 16.963 7.038 21 12 21C16.963 21 21 16.963 21 12C21 7.038 16.963 3 12 3ZM12 23C5.935 23 1 18.065 1 12C1 5.935 5.935 1 12 1C18.065 1 23 5.935 23 12C23 18.065 18.065 23 12 23ZM12 13C11.448 13 11 12.552 11 12V8C11 7.448 11.448 7 12 7C12.552 7 13 7.448 13 8V12C13 12.552 12.552 13 12 13ZM11.29 16.702C11.48 16.892 11.73 17.002 12 17.002C12.27 17.002 12.52 16.892 12.71 16.702C12.9 16.522 13 16.272 13 16.002C13 15.872 12.98 15.742 12.92 15.622C12.87 15.492 12.8 15.382 12.71 15.292C12.43 15.012 11.98 14.922 11.62 15.071C11.49 15.122 11.39 15.202 11.29 15.292C11.2 15.382 11.13 15.492 11.08 15.622C11.03 15.742 11 15.872 11 16.002C11 16.272 11.1 16.522 11.29 16.702Z",
    fill: "#C86B6D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_735_6646",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 22,
    height: 22
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C7.038 3 3 7.038 3 12C3 16.963 7.038 21 12 21C16.963 21 21 16.963 21 12C21 7.038 16.963 3 12 3ZM12 23C5.935 23 1 18.065 1 12C1 5.935 5.935 1 12 1C18.065 1 23 5.935 23 12C23 18.065 18.065 23 12 23ZM12 13C11.448 13 11 12.552 11 12V8C11 7.448 11.448 7 12 7C12.552 7 13 7.448 13 8V12C13 12.552 12.552 13 12 13ZM11.29 16.702C11.48 16.892 11.73 17.002 12 17.002C12.27 17.002 12.52 16.892 12.71 16.702C12.9 16.522 13 16.272 13 16.002C13 15.872 12.98 15.742 12.92 15.622C12.87 15.492 12.8 15.382 12.71 15.292C12.43 15.012 11.98 14.922 11.62 15.071C11.49 15.122 11.39 15.202 11.29 15.292C11.2 15.382 11.13 15.492 11.08 15.622C11.03 15.742 11 15.872 11 16.002C11 16.272 11.1 16.522 11.29 16.702Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_735_6646)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCircle);
export default __webpack_public_path__ + "static/media/Alert-circle.5a50991917e44344a6649db4e3ed8d36.svg";
export { ForwardRef as ReactComponent };